import {
  AvailablePermissions,
  Environment,
  PermissionAdapterInterface,
  PermissionStatus,
} from "@citychallenge/core";

export class PermissionsAdapter implements PermissionAdapterInterface {
  private IS_IOS = Environment.OS === "ios";

  public async checkPermission(
    permission: AvailablePermissions
  ): Promise<PermissionStatus> {
    // TODO: Implement
    if (permission === "camera") {
      return "denied";
    }

    if (permission === "location") {
      return "denied";
    }

    if (permission === "notification") {
      return "denied";
    }

    return "denied";
  }

  public requestPermission = async (
    _permission: AvailablePermissions
  ): Promise<PermissionStatus> => {
    // TODO: Implement
    return "denied";
  };
}
